/** 进路方向（键名供页面逻辑判断，值即存库文案） */
const pathDirection = {
  xueBu: "升学-学部",
  xiuShi: "升学-修士",
  zhuanShengBen: "升学-专升本", // 历史值，与编入同义；大专选项已去掉，编辑时自动归并到编入
  zhuanShengShuo: "升学-专升硕",
  bianRu: "升学-编入",
  preparatory: "研究生预科",
  zhuanMen: "专门学校",
  job: "在日就职",
  returnHome: "回国",
  phd: "读博",
  invest: "投资经营",
  other: "其他"
};

const pathDirectionList = [
  pathDirection.xueBu,
  pathDirection.xiuShi,
  pathDirection.zhuanShengShuo,
  pathDirection.bianRu,
  pathDirection.preparatory,
  pathDirection.zhuanMen,
  pathDirection.job,
  pathDirection.returnHome,
  pathDirection.phd,
  pathDirection.invest,
  pathDirection.other
];

/** 按钮展示名（存库仍用 pathDirection 原文） */
const pathDirectionLabel = {};
pathDirectionLabel[pathDirection.xueBu] = "考学部";
pathDirectionLabel[pathDirection.xiuShi] = "考修士";
pathDirectionLabel[pathDirection.zhuanShengBen] = "专升本";
pathDirectionLabel[pathDirection.zhuanShengShuo] = "专升硕";
pathDirectionLabel[pathDirection.bianRu] = "编入";
pathDirectionLabel[pathDirection.preparatory] = "研究生预科";
pathDirectionLabel[pathDirection.zhuanMen] = "专门学校";
pathDirectionLabel[pathDirection.job] = "就职";
pathDirectionLabel["就职"] = "就职"; // 兼容旧存库值
pathDirectionLabel[pathDirection.returnHome] = "回国";
pathDirectionLabel[pathDirection.phd] = "读博";
pathDirectionLabel[pathDirection.invest] = "投资经营";
pathDirectionLabel[pathDirection.other] = "其他";

/**
 * 学历 → 可选进路方向（按业务表）
 * 未选学历时返回全部
 */
function getPathDirectionsByEdu(eduBack) {
  var d = pathDirection;
  var edu = (eduBack || "").trim();
  if (!edu || edu === "其他") return pathDirectionList.slice();

  // 高中 / 中专高职 / 3+2大专：考学部、专门学校、回国、其他
  if (edu === "高中" || edu === "中专/高职" || edu === "3+2大专") {
    return [d.xueBu, d.zhuanMen, d.returnHome, d.other];
  }
  // 本科：考学部、考修士、研究生预科、专门学校、就职、回国、投资经营、其他
  if (edu === "本科") {
    return [d.xueBu, d.xiuShi, d.preparatory, d.zhuanMen, d.job, d.returnHome, d.invest, d.other];
  }
  // 大专：考学部、专升硕、编入、专门学校、就职、回国、其他（专升本已并入编入）
  if (edu === "大专") {
    return [d.xueBu, d.zhuanShengShuo, d.bianRu, d.zhuanMen, d.job, d.returnHome, d.other];
  }
  // 硕士：考修士、研究生预科、就职、专门学校、读博、投资经营、其他（含重修修士）
  if (edu === "修士（硕士）" || edu === "硕士") {
    return [d.xiuShi, d.preparatory, d.job, d.zhuanMen, d.phd, d.invest, d.other];
  }
  // 博士：未单独约定，暂同硕士
  if (edu === "博士") {
    return [d.job, d.zhuanMen, d.phd, d.invest, d.other];
  }
  return pathDirectionList.slice();
}

export default {
  pathDirection,
  pathDirectionLabel,
  getPathDirectionsByEdu,
  /** 学历 */
  eduList: [
    "高中",
    "本科",
    "大专",
    "修士（硕士）",
    "中专/高职",
    "3+2大专",
    "博士",
    "其他"
  ],
  /** 进路方向下拉（顺序即下拉展示顺序） */
  pathDirectionList,
  /** 企业类型（在日就职） */
  companyTypeList: [
    "日企",
    "华人企业",
    "外企"
  ],
  /** 企业规模（在日就职） */
  companyScaleList: [
    "上市公司",
    "大型企业",
    "中小企业"
  ],
  /** 就职历程（在日就职） */
  jobPathList: [
    "语校直接就职",
    "考学后就职",
    "专门学校就职"
  ],
  /** 入学方式（升学-专升硕） */
  enrollMethodList: [
    "直考修士",
    "研究生预科"
  ],
  /** 文理：高中/大专/中专等-学部 */
  artsScienceListXueBu: ["文科", "理科", "艺术"],
  /** 文理：本科-学部（含工科，与导入模板一致） */
  artsScienceListBenKeXueBu: ["文科", "理科", "工科", "艺术"],
  /** 文理：大专-专升硕/编入、本科-修士 */
  artsScienceListAdv: ["文科", "理科", "工科", "艺术"],
  /** 列表筛选用全部文理选项 */
  artsScienceFilterList: ["文科", "理科", "工科", "艺术"],
  /**
   * 按学历+进路返回文理下拉；不适用返回空数组
   * 高中/中专高职/3+2大专/大专+学部 → 文理艺
   * 本科+学部 → 文理工艺
   * 大专+专升硕/编入、本科+修士/研究生预科 → 文理工艺
   */
  getArtsScienceList(eduBack, pathDir) {
    var d = pathDirection;
    var edu = (eduBack || "").trim();
    var xueBuEdu = edu === "高中" || edu === "大专" || edu === "中专/高职" || edu === "3+2大专" || edu === "本科";
    if (pathDir === d.xueBu && xueBuEdu) {
      if (edu === "本科") return this.artsScienceListBenKeXueBu.slice();
      return this.artsScienceListXueBu.slice();
    }
    if (pathDir === d.zhuanShengShuo || pathDir === d.bianRu) {
      return this.artsScienceListAdv.slice();
    }
    if ((pathDir === d.xiuShi || pathDir === d.preparatory) && (edu === "本科" || edu === "修士（硕士）" || edu === "硕士")) {
      return this.artsScienceListAdv.slice();
    }
    return [];
  },
  /** 按钮展示名（学部统一显示「考学部」） */
  pathDirectionDisplay(dir, eduBack) {
    return (pathDirectionLabel && pathDirectionLabel[dir]) || dir || "";
  },
  /** 英语考试类型 */
  englishTypeList: [
    "托福",
    "托业",
    "雅思",
    "无"
  ],
  /** 需要填分数的英语类型 */
  englishScoreTypes: ["托福", "托业", "雅思"],
  /** 回访列表筛选：英语（不含「无」） */
  englishFilterList() {
    return this.englishTypeList
      .filter(function(x) { return x !== "无"; })
      .map(function(x) { return { id: x, name: x }; });
  }
};
